module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABC0lEQVRYR+2W0Q3CIBBAORhAR7G5DlA30Q10FDfQSdQJ2lF0gBaDqQlBKnDl2pi0f3zcvdfjjhyImT+YmS8Wgf+uQF3XG9NDRVE01F4iV8DAu667GrCUckuVIAlY8HX/5ydEPFCqkCzgwrXWl7IsdxS4iUkSyA1PEuCARwtwwaMEOOFBAW74TwEPvJFSkkbtDQJ4+t4K7xR45pw6ZXbcHRErN9GgQNu2NwBY5SD3OeIFTICpgi2htW6UUscRQo/oK/hAXAkhxBkR9yMkvkKDLyG3RFDAdx05KxElwCkRLcAlkSTAIZEsMCAx3ULijqg5K6WqSVcyW2K2pTTXY0TqgVzw4D6QEzSUa6nAC/szxCH90VEuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 1